import { useCallback, useMemo } from 'react';

import { Button } from '@mui/material';
import { RiFileExcel2Fill } from 'react-icons/ri';

import { useFormContext } from 'context/FormContext';
import { useListagemContext } from 'context/ListagemContext';
import { useDownloadFile } from 'hooks/useDownloadFile';
import { RequestOptionsType } from 'hooks/useRequestListagem';

export function PedidoRealizadoRelatorioBtn() {
    const { content } = useFormContext();
    const { filter } = useListagemContext();

    const requestOptions: RequestOptionsType = useMemo(
        () => ({
            url: '/compra/pedidoproduto/exportar',
            sort: [{ property: 'idPedido', direction: 'DESC' }],
            filter,
        }),
        [filter],
    );

    const { isLoadingFile, downloadFile } = useDownloadFile({ requestOptions });

    const handleClickDownload = useCallback((): void => {
        downloadFile({
            newRequestOptions: requestOptions,
            directDownload: true,
        });
    }, [downloadFile, requestOptions]);

    return (
        <Button
            loading={isLoadingFile}
            variant="outlined"
            onClick={handleClickDownload}
            disabled={!content || isLoadingFile}
            sx={{ color: 'green', borderColor: 'green', flex: { xs: 'auto', md: 'none' } }}
            startIcon={<RiFileExcel2Fill />}
        >
            Relatório em .xlsx
        </Button>
    );
}
